/* globals Stripe */
$(function() {
	// @codekit-prepend 'js/functions.js'
	// @codekit-prepend 'js/accounts.js'
	// @codekit-prepend 'js/appointments.js'
	// @codekit-prepend 'js/my-appointments.js'
	// @codekit-prepend 'js/membership.js'
	// @codekit-prepend 'js/gift-membership.js'
	
});